export default __webpack_public_path__ + "static/media/higher_primary_logo_tagline_uppercase_reversed.181264ec.svg";